import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { WIDGET_TYPE_REGISTRY, WidgetTypeInfo } from './dashboard-widget.interface';

@Component({
  selector: 'app-widget-picker-dialog',
  template: `
    <ng-container *ngFor="let section of sections">
      <div class="widget-picker-section px-4 pt-4 font-semibold text-sm uppercase tracking-wide">{{ section.title }}</div>
      <div class="grid grid-cols-2 gap-4 p-4">
        <div
          *ngFor="let widget of section.widgets"
          class="widget-card p-4 border rounded-lg cursor-pointer transition-colors"
          [class.dash-kpi-tint]="widget.isKpi"
          [class.selected]="selectedWidget === widget"
          (click)="selectWidget(widget)">
          <h4 class="font-semibold mb-2 flex items-center gap-2">
            <span *ngIf="widget.isKpi" class="dash-kpi-badge">KPI</span>
            <span *ngIf="widget.usesAccountFilter" class="dash-filter-badge" title="This widget uses the Account Filter.">FILTER</span>
            <span>{{ widget.name }}</span>
          </h4>
          <p class="text-sm text-gray-600">{{ widget.description }}</p>
          <div class="text-xs text-gray-400 mt-2">
            Default size: {{ widget.defaultCols }} x {{ widget.defaultRows }}
          </div>
        </div>
      </div>
    </ng-container>
    <div class="flex justify-end gap-2 p-4 border-t">
      <button pButton label="Cancel" class="p-button-text" (click)="cancel()"></button>
      <button pButton label="Add Widget" [disabled]="!selectedWidget" (click)="confirm()"></button>
    </div>
  `,
  styles: [`
    .widget-card {
      border-color: var(--surface-border);
    }
    .widget-card:hover {
      border-color: var(--primary-color);
    }
    .widget-card.selected {
      border-color: var(--primary-color);
      background-color: var(--primary-50);
      box-shadow: 0 0 0 1px var(--p-primary-color, var(--primary-color));
    }
  `],
  standalone: false,
})
export class WidgetPickerDialogComponent {
  sections = [
    { title: 'KPI Widgets', widgets: WIDGET_TYPE_REGISTRY.filter((w) => w.isKpi) },
    { title: 'Standard Widgets', widgets: WIDGET_TYPE_REGISTRY.filter((w) => !w.isKpi) },
  ];
  selectedWidget: WidgetTypeInfo | null = null;

  constructor(private dialogRef: DynamicDialogRef) {}

  selectWidget(widget: WidgetTypeInfo): void {
    this.selectedWidget = widget;
  }

  confirm(): void {
    this.dialogRef.close(this.selectedWidget);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
